import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

class CartService{

    async setCart(token, carrello){
        return axios({
            method: 'post',
            url: API_URL + 'carrello/SetCarrello',
            data: carrello,
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            }
        }).then(
            data => {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }

    async updateRow(token, idCarrello, codiceArticolo, quantita, isBackorder){
        return axios({
            method: 'put',
            url: API_URL + 'carrello/UpdateRigaCarrello',
            data:{
                quantita: quantita
            },
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            },
            params:{
                idCarrello: idCarrello,
                codiceArticolo: codiceArticolo,
                isBackorder: isBackorder
            }
        })
        .then(
            data =>  {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }

    async deleteRow(token, idCarrello, codiceArticolo, isBackorder){
        return axios({
            method: 'delete',
            url: API_URL + 'carrello/DeleteRigaCarrello',
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            },
            params:{
                idCarrello: idCarrello,
                codiceArticolo: codiceArticolo,
                isBackorder: isBackorder
            }
        })
        .then(
            data =>  {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }

    async getCartByUsername(token){
        return axios({
            method: 'get',
            url: API_URL + 'carrello/GetCarrelloByUsername',
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            }
        })
        .then(
            data =>  {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }

    async CalcolaSpSpedizione(token, indirizzo, shop){
        return axios({
            method: 'get',
            url: API_URL + 'carrello/GetSpeseDiSpedizione',
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            },
            params:{
                codiceDestinazione: indirizzo,
                codShop: shop
            }
        })
        .then(
            data =>  {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }

    async setSeasonalDate(token, idCarrello, data){
        return axios({
            method: 'put',
            url: API_URL + 'carrello/SetSeasonalDate',
            headers:{
                Authorization: 'Bearer '+ token,
                'Content-Type': 'application/json'
            },
            params:{
                codCart: idCarrello,
                date: data
            }
        })
        .then(
            data =>  {
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }
            }
        )
        .catch(error => {return error;});
    }
}

export default new CartService();